import { render, staticRenderFns } from "./shangmen-view.vue?vue&type=template&id=3ee6439e&scoped=true&"
import script from "./shangmen-view.vue?vue&type=script&lang=js&"
export * from "./shangmen-view.vue?vue&type=script&lang=js&"
import style0 from "./shangmen-view.vue?vue&type=style&index=0&id=3ee6439e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee6439e",
  null
  
)

component.options.__file = "shangmen-view.vue"
export default component.exports